import React from 'react';

const MessageMediaGallery = ({ mediaList }) => {
  if (!Array.isArray(mediaList) || mediaList.length === 0) {
    return null;
  }

  return (
    <div className="message-media-grid">
      {mediaList.map((media, index) => {
        const key = media._id || `${media.mediaType || 'media'}-${index}`;
        const isLocked = Boolean(media.isLocked);
        const isPurchased = Boolean(media.isBought);
        const hasOverlay = isLocked || isPurchased;
        const amount =
          typeof media.amount === 'number' || typeof media.amount === 'string'
            ? `${media.amount}€`
            : null;

        const baseImage = media.src?.normal || media.src?.blur || media.src?.small;
        const isVideo = media.mediaType === 'video';
        const videoSrc = typeof media.video === 'string' && media.video ? media.video : null;

        return (
          <div key={key} className="media-grid-item">
            {isVideo && videoSrc ? (
              <video
                className="media-grid-video"
                controls
                preload="metadata"
                playsInline
                poster={baseImage || undefined}
                src={videoSrc}
              >
                Votre navigateur ne supporte pas les vidéos.
              </video>
            ) : baseImage ? (
              <img
                className="media-grid-image"
                src={baseImage}
                alt={isVideo ? 'Aperçu vidéo' : 'Média partagé'}
                loading="lazy"
              />
            ) : null}

            {hasOverlay && (
              <div className={`media-grid-overlay ${isLocked ? 'locked' : 'purchased'}`}>
                <span className="overlay-icon">{isLocked ? '🔒' : '✅'}</span>
                <span className="overlay-text">
                  {isLocked ? 'Contenu verrouillé' : 'Contenu acheté'}
                </span>
                {amount && <span className="overlay-price">{amount}</span>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MessageMediaGallery;

